/* eslint-disable max-len */
import cx from 'clsx';

// types
// styles
import { useStyles } from './shared/styles';

const Sent = ({ className, color, onClick }) => {
  const classes = useStyles();

  return (
    <svg
      className={cx({
        [classes.root]: true,
        [className || '']: className,
      })}
      onClick={onClick}
      width="24"
      height="24"
      viewBox="0 0 11 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.66667 2V3.33333C9.77133 3.33333 10.6667 4.22867 10.6667 5.33333V12.6667C10.6667 13.0347 10.368 13.3333 10 13.3333H0.666667C0.298667 13.3333 0 13.0347 0 12.6667V5.33333C0 4.22867 0.895333 3.33333 2 3.33333V2H8.66667ZM6 6H4.66667V7.33333H3.33333V8.66667H4.666L4.66667 10H6L5.99933 8.66667H7.33333V7.33333H6V6ZM10 0V1.33333H0.666667V0H10Z"
        fill={color}
      />
    </svg>
  );
};

export default Sent;
